import React from "react"

import {
    css,
    Grid,
    GridCell,
    InputGroup,
} from "@bdfx/mergado-ui-kit"

import trans from "trans"

import { NumericInput } from "./fields";
import { CIRCLE_TEXT_TYPE } from "shape-entities/types/shape";
import { URL } from "app/config/api-config";
import { TEXT_DIRECTION_CLOCKWISE, TEXT_DIRECTION_COUNTER_CLOCKWISE } from "shape-entities/render-text";
import { Input, Slider } from "@mui/material";

const { min, max, abs, sin, cos, PI, round, atan2, sqrt, ceil } = Math

const TextOptionsTwoForm = ({ formName, shape, activeShapeId, change }) => {
    const allowLineSpacing = (!!shape.text_wrap || !!shape.text_orientation)

    return (
        <React.Fragment>
            <GridCell col={'1/-1'} style={{padding: '10px'}}>
                <Grid cols={'auto max-content'} gap={'20px'}>
                    <GridCell>
                        {trans('lines_and_letters_spacing')}<br/>
                        <StyledSlider
                            size={"small"}
                            value={round(shape.letter_spacing)}
                            onChange={(event, value: number) => {
                                change(formName, `shapes.${activeShapeId}.letter_spacing`, value)
                            }}
                            track="normal"
                            defaultValue={0}
                            marks={[{ value: -10 }, { value: 0 }, { value: 50 }]}
                            min={-10}
                            max={50}
                            step={1}
                            valueLabelDisplay="off"
                        />
                    </GridCell>
                    <GridCell style={{alignSelf: 'center'}}>
                        <StyledInput
                            value={round(shape.letter_spacing)}
                            size="small"
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => change(formName, `shapes.${activeShapeId}.letter_spacing`, event.target.value === '' ? 0 : Number(event.target.value))}
                            inputProps={{
                                step: 10,
                                min: -10,
                                max: 50,
                                type: 'number',
                                'aria-labelledby': 'input-slider',
                            }}
                        />
                    </GridCell>
                    {allowLineSpacing &&
                        <React.Fragment>
                            <GridCell style={{ alignSelf: 'end' }}>
                                {trans('line_spacing')}<br />
                                <StyledSlider
                                    size={"small"}
                                    value={round(shape.line_spacing)}
                                    onChange={(event, value: number) => change(formName, `shapes.${activeShapeId}.line_spacing`, value)}
                                    defaultValue={0}
                                    marks={[{ value: -50 }, { value: 0 }, { value: 100 }]}
                                    min={-50}
                                    max={100}
                                    step={1}
                                    valueLabelDisplay="off"
                                />
                            </GridCell>
                            <GridCell style={{ alignSelf: 'center' }}>
                                <StyledInput
                                    value={round(shape.line_spacing)}
                                    size="small"
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => change(formName, `shapes.${activeShapeId}.line_spacing`, event.target.value === '' ? 0 : Number(event.target.value))}
                                    inputProps={{
                                        step: 10,
                                        min: -50,
                                        max: 100,
                                        type: 'number',
                                        'aria-labelledby': 'input-slider',
                                    }}
                                />
                            </GridCell>
                        </React.Fragment>
                    }
                </Grid>
            </GridCell>

            {!!(shape.text_align || shape.text_valign) &&
                <React.Fragment>
                    <GridCell style={{ alignSelf: 'center' }}>{trans('text_padding')}</GridCell>
                    <GridCell title={trans('text_padding')}>
                        <Grid cols="1fr 1fr 1fr">
                            <GridCell />
                            <GridCell />
                            <GridCell>
                                <NumericInput
                                    formName={formName}
                                    fieldName={'text_padding'}
                                    placeholder={'text_padding'}
                                    id={'text_padding'}
                                    style={{ width: 'auto' }}
                                    min={0}
                                    max={round(min(shape.width, shape.height) / 2)}
                                    step={1}
                                    units={'px'}
                                    value={shape.text_padding}
                                    onlyPositive={true}
                                    changeValueMethod={(value: number) => {
                                        change(formName, `shapes.${activeShapeId}.text_padding`, value)
                                        //updateShapeSizeDebounced(subFormName, activeShapeId, true)
                                        return value
                                    }}
                                />
                            </GridCell>
                        </Grid>
                    </GridCell>
                </React.Fragment>
            }

            {shape.type === CIRCLE_TEXT_TYPE &&
                <React.Fragment>
                    <GridCell style={{ alignSelf: 'center' }}>{trans('text_direction')}</GridCell>
                    <GridCell className={'hide-buttons horizontal-fixed-size'}>
                        <StyledInputGroup
                            orientation="horizontal"
                            onChange={(textDirection: number) => change(formName, `shapes.${activeShapeId}.text_direction`, textDirection)}
                            singleChoice={true}
                            value={shape.text_direction || TEXT_DIRECTION_CLOCKWISE}
                            items={[
                                { value: TEXT_DIRECTION_CLOCKWISE, label: <img src={`${URL.publicPath}img/icons/text-direction-clockwise.svg`} height={32} title={trans('clockwise')} /> },
                                { value: TEXT_DIRECTION_COUNTER_CLOCKWISE, label: <img src={`${URL.publicPath}img/icons/text-direction-counter-clockwise.svg`} height={32} title={trans('counter_clockwise')} /> },
                            ]}
                        />
                    </GridCell>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

const StyledSlider = css(Slider)({
})

const StyledInput = css(Input)({
    ' input': {
        backgroundColor: 'transparent',
    },
})

const StyledInputGroup = css(InputGroup)({
    ' span.muk-button.secondary': {
        display: 'grid',
        height: '45px',
        padding: 0,
    },
    ' .muk-span.m-input-wrapper': {
        height: 'auto !important',
    },
    ' span.m-radio-input': {
        display: 'none',
    },
    ' .fullwidth': {
        padding: '15px 20px',
    },
})

export default TextOptionsTwoForm